// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ServiciosTable_spinnerContainer__anpCk"};